// import "../Users/Users.scss"; // Removed for version update
import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import store from "../../../store";
import { addNewPermission } from "../../../store/actions/permissions";

const AddRejectNote = ({ id, setSearchFlag, setRejectNotePopUP }) => {
  console.log("Reject Note", id);
  let [rejectNote, setRejectNote] = useState("");

  const closeModal = () => {
    setRejectNote("");
    setRejectNotePopUP(false);
    document.getElementById("go-modal").classList.remove("open");
  };

  const onSubmit = () => {
    // e.preventDefault();
    let token = localStorage.getItem("token");

    const headers = {
      "Content-Type": "application/json",
      authorization: token,
    };

    if (rejectNote == "") {
      toast.error("Please Enter Reject Note", {
        position: "top-center",
        autoClose: 1500,
      });
      return;
    }

    let temp = {
      status: "rejected",
      reject_note: rejectNote,
    };
    axios
      .post(
        process.env.BASE_URL + `/api/merchant/historical-data/${id}`,
        temp,
        {
          headers: headers,
        }
      )
      .then((res) => {
        console.log("Response", res);
        setSearchFlag((flag) => !flag);
        toast.success("Status Updated", {
          autoClose: 1500,
          position: "top-center",
        });
        closeModal();
      })
      .catch((err) => {
        console.log("error", err);
      });
  };

  return (
    <div className="go-modal" id="go-modal">
      <div className="overlay"></div>
      <div className="go-modal-card">
        <a
          className="close-modal"
          onClick={() => {
            closeModal();
            setRejectNote("");
          }}
          href="javascript:;"
        >
          <img src="/images/close.svg" />
        </a>
        <div className="go-modal-header">
          <h3 class="fs20 lh-25 metro-m text-d-blue margin-t10">
            Add Reject Note
          </h3>
        </div>
        <div className="go-modal-content">
          {/* <form className="add-reject-note"> */}
          <div className="form-group">
            <label
              className="fs14 lh-14 text-l-blue metro-r margin-b8"
              htmlFor="name"
            >
              <span className="text-danger fs18">*</span>Reject Note
            </label>
            <textarea
              type="text"
              className="form-control"
              placeholder="Enter Reject Note"
              id="name"
              rows={4}
              value={rejectNote}
              onChange={(e) => setRejectNote(e.target.value)}
            />
          </div>
          <div className="form-group margin-t40 text-right">
            <button className="blue-btn auto-w-btn" onClick={onSubmit}>
              Save
            </button>
          </div>
          {/* </form> */}
        </div>
      </div>
    </div>
  );
};

export default AddRejectNote;
